import { render, staticRenderFns } from "./ProductServiceCategoryList.vue?vue&type=template&id=cbcfa8ba&"
import script from "./ProductServiceCategoryList.js?vue&type=script&lang=js&"
export * from "./ProductServiceCategoryList.js?vue&type=script&lang=js&"
import style0 from "./ProductServiceCategoryList.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports